const BYTE_MULTIPLIER = 1024;

export const getBytesAmountByUnit = (bytes) => {
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

  if (!bytes) {
    return [0, 'Bytes'];
  }

  const sizeIndex = parseInt(
    Math.floor(Math.log(bytes) / Math.log(BYTE_MULTIPLIER))
  );
  const sizeLabel = sizes[sizeIndex];
  const sizeAmount = Math.round(bytes / Math.pow(BYTE_MULTIPLIER, sizeIndex));

  return [sizeAmount, sizeLabel];
};

export const formatBytes = (bytes) => {
  const [amount, unit] = getBytesAmountByUnit(bytes);

  return `${amount} ${unit}`;
};

export const parseMediaUrl = (url) => {
  url.match(
    /(https?:\/\/|\/\/|)(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(&\S+)?/
  );
  let type = null;

  if (RegExp.$3.indexOf('youtu') > -1) {
    type = 'YOUTUBE';
  } else if (RegExp.$3.indexOf('vimeo') > -1) {
    type = 'VIMEO';
  }

  return {
    type,
    id: RegExp.$6
  };
};

export const exportCSV = (file, fileName) => {
  const encodedUri = encodeURI(file);
  const uri = `data:text/csv;charset=utf-8,${encodedUri}`;
  const downloadLink = document.createElement('a');

  downloadLink.href = uri;
  downloadLink.download = `${fileName}.csv`;

  document.body.appendChild(downloadLink);
  downloadLink.click();
  document.body.removeChild(downloadLink);
};
